module.exports = __webpack_public_path__ + "img/TA.31c5be20.svg";